import { useEffect } from 'react';

// Close a hand-rolled dialog on Escape. `enabled` lets a component that renders
// its dialog inline (rather than as a child component) attach the listener only
// while the dialog is actually open.
const useEscapeToClose = (onClose, enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose, enabled]);
};

export default useEscapeToClose;
